import type { SVGProps } from 'react';

interface YoutubeIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const YoutubeIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & YoutubeIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 25 25"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <rect fill="#4FA9FF" height={25} rx={12.5} width={25} />
    <g clipPath="url(#youtube_svg__a)">
      <path
        d="M15.51 12.618a.42.42 0 0 0-.252-.406l-3.99-2.52a.5.5 0 0 0-.504-.007q-.266.133-.266.455v4.97q0 .323.252.434.126.084.259.084a.46.46 0 0 0 .259-.084l3.99-2.506a.43.43 0 0 0 .252-.42m3.99 0v1.176q0 .406-.084 1.078-.042.644-.168 1.148a1.66 1.66 0 0 1-.546.952q-.35.363-.952.462-2.058.195-5.25.196-3.192 0-5.25-.196-.602-.099-.952-.462a1.66 1.66 0 0 1-.546-.952 6.5 6.5 0 0 1-.168-1.148 9 9 0 0 1-.084-1.078v-2.352q0-.392.084-1.064.042-.644.168-1.148.112-.574.546-.952.35-.365.952-.462 2.058-.196 5.25-.196t5.25.196q.602.098.952.462.434.379.546.952.126.504.168 1.148.084.672.084 1.064z"
        fill="#F8F8F8"
      />
    </g>
    <defs>
      <clipPath id="youtube_svg__a">
        <path d="M5.5 20.5h14v-14h-14z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
